import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import {
  useChannelStateContext,
  useChatContext,
  MessageInput as DefaultMessageInput,
  MessageInputProps,
} from 'stream-chat-react';
import type { SendMessageOptions, Message, Channel } from 'stream-chat';

import { joinChannel } from '@/generated/client/chat/chat';

import './CustomMessageInput.css';

const CustomMessageInput: React.FC<MessageInputProps> = (props) => {
  const { channel } = useChannelStateContext();
  const { client } = useChatContext();
  const { t } = useTranslation();

  const userId = client.user?.id;
  if (!channel || !userId) return null;
  if (channel.type === 'FORM_LETTER') {
    return <MyMessageInput props={props} channel={channel} />;
  }

  const isUserMember = !!channel.state.members[userId];

  async function joinSelfToChannel() {
    await joinChannel({ channelId: channel.id! });
    // just to trigger message list update
    await channel.addMembers([userId!]);
    await channel.sendMessage({
      text: `${client.user?.name} ${t('streamChat.custom.joinedChannel')}`,
      type: 'system',
    });
  }

  if (isUserMember) {
    return <MyMessageInput props={props} channel={channel} />;
  } else {
    return (
      <div>
        <Button onClick={joinSelfToChannel} className="channel-join-button">
          {t('streamChat.custom.joinChannel')}
        </Button>
      </div>
    );
  }
};

function MyMessageInput({ props, channel }: { props: MessageInputProps; channel: Channel }) {
  return (
    <DefaultMessageInput
      {...props}
      minRows={1}
      maxRows={6}
      overrideSubmitHandler={async ({
        message,
        sendOptions,
      }: {
        message: Message;
        sendOptions?: SendMessageOptions;
      }) => {
        const messageText = message.text;
        message.text = messageText?.replace('.', '\\.').replace(')', '\\)');
        await channel.sendMessage(message, sendOptions);
      }}
    />
  );
}

export default CustomMessageInput;
